export enum ServiceName {
  Analytics = 'Analytics',
  Auth = 'Auth',
  Demo = 'Demo',
  Diagnostics = 'Diagnostics',
  Draft = 'Draft',
  Libraries = 'Libraries',
  Resources = 'Resources',
  Vendor = 'Vendor'
}